var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import Icon from '@anwb/icon';
import { RadioCheckboxInput } from './components';
import { CheckboxBasic, RadioCheckboxLabel } from './styles';
// eslint-disable-next-line prefer-arrow-callback
export const Checkbox = forwardRef(function CheckboxWithForwardRef(_a, ref) {
    var { children, reference, disabled, dataTest = 'checkbox', colorContext = 'on-light' } = _a, props = __rest(_a, ["children", "reference", "disabled", "dataTest", "colorContext"]);
    return (React.createElement(RadioCheckboxLabel, { htmlFor: reference, "$disabled": disabled === true, "$colorContext": colorContext },
        React.createElement(RadioCheckboxInput, Object.assign({ reference: reference, disabled: disabled, type: "checkbox", ref: ref, "data-test": `${dataTest}-input` }, props)),
        React.createElement(CheckboxBasic, { "$colorContext": colorContext },
            React.createElement(Icon, { variant: "checkbox" })),
        children));
});
//# sourceMappingURL=Checkbox.js.map